module.exports = __webpack_public_path__ + "fonts/SalesforceSans-LightItalic.8080e8bc6c523ed5c657931fdd80e032.woff";